// extracted by mini-css-extract-plugin
export var externalLink = "_ao-0";
export var internalLinkLabel = "_ao-1";